import React from 'react';

const UsersIconV2 = ({ className, style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    className,
    style: { ...style, overflow: "visible" },
    xmlns: "http://www.w3.org/2000/svg",
    width: "14",
    height: "12",
    viewBox: "0 0 14 12",
    fill: "none"
  },
  /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_1443_17361)" }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M2.03023 5.25773C2.77676 5.25773 3.38372 4.65077 3.38372 3.90424C3.38372 3.15771 2.77676 2.55075 2.03023 2.55075C1.2837 2.55075 0.676743 3.15771 0.676743 3.90424C0.676743 4.65077 1.2837 5.25773 2.03023 5.25773ZM11.5046 5.25773C12.2512 5.25773 12.8581 4.65077 12.8581 3.90424C12.8581 3.15771 12.2512 2.55075 11.5046 2.55075C10.7581 2.55075 10.1512 3.15771 10.1512 3.90424C10.1512 4.65077 10.7581 5.25773 11.5046 5.25773ZM12.1814 5.93447H10.8279C10.4557 5.93447 10.1194 6.08462 9.87411 6.32783C10.7264 6.7952 11.3312 7.63902 11.4623 8.64144H12.8581C13.2324 8.64144 13.5349 8.33902 13.5349 7.9647V7.28796C13.5349 6.54142 12.9279 5.93447 12.1814 5.93447ZM6.76743 5.93447C8.07651 5.93447 9.13604 4.87494 9.13604 3.56587C9.13604 2.25679 8.07651 1.19727 6.76743 1.19727C5.45836 1.19727 4.39883 2.25679 4.39883 3.56587C4.39883 4.87494 5.45836 5.93447 6.76743 5.93447ZM8.39162 6.61121H8.21609C7.77621 6.8227 7.28768 6.94959 6.76743 6.94959C6.24719 6.94959 5.76078 6.8227 5.31878 6.61121H5.14325C3.79822 6.61121 2.70697 7.70246 2.70697 9.04749V9.65656C2.70697 10.217 3.16166 10.6717 3.72209 10.6717H9.81278C10.3732 10.6717 10.8279 10.217 10.8279 9.65656V9.04749C10.8279 7.70246 9.73665 6.61121 8.39162 6.61121ZM3.66076 6.32783C3.41544 6.08462 3.07918 5.93447 2.70697 5.93447H1.35349C0.606954 5.93447 0 6.54142 0 7.28796V7.9647C0 8.33902 0.30242 8.64144 0.676743 8.64144H2.07041C2.20365 7.63902 2.80849 6.7952 3.66076 6.32783Z",
      fill: "#00FFFF"
    }
  )),
  /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_1443_17361" }, /* @__PURE__ */ React.createElement(
    "rect",
    {
      width: "13.5349",
      height: "10.8279",
      fill: "white",
      transform: "translate(0 0.521484)"
    }
  )))
);
UsersIconV2.displayName = "Icons.UsersIconV2";

export { UsersIconV2 };
//# sourceMappingURL=UsersIconV2.js.map
